import { environment } from "@/environments/environment";
import Hotjar from "@hotjar/browser";

const hotjarVersion = 6;

(() => {
  window.addEventListener("cf_consent_loaded", function (event) {
    const previouslySavedConsent = (event as CustomEvent).detail;

    if (previouslySavedConsent?.advertising) {
      Hotjar.init(environment.hotjarSiteId, hotjarVersion);
    }
  });

  window.addEventListener("cf_consent", function (event) {
    const currentConsent = (event as CustomEvent).detail;

    if (currentConsent?.advertising) {
      Hotjar.init(environment.hotjarSiteId, hotjarVersion);
    }
  });
})();
